export default class Team {
    constructor() {
        this.id = "";
        this.collaborator = { id: "", content: "" };
        this.dateStart = "";
        this.timeStart = "";
        this.dateEnd = "";
        this.timeEnd = "";
        this.description = "";
        this.dueDate = "";
        this.value = 0;
        this.payableReceivable = {};
        this.genericId = "";
        this.statusName = "";
        this.approvedBy = "";
        this.rejectionReason = "";
    }
    update(data) {
        this.id = data.id;
        this.collaborator = { id: data.collaboratorId, content: data.collaboratorName };
        this.dateStart = data.dateStart;
        this.timeStart = data.timeStart;
        this.dateEnd = data.dateEnd;
        this.timeEnd = data.timeEnd;
        this.description = data.description;
        this.dueDate = data.dueDate;
        this.value = data.value;
        this.payableReceivable = data.payableReceivable;
        this.genericId = data.genericId;
        this.statusName = data.statusName || data.StatusName || "";
        this.approvedBy = data.approvedBy || data.ApprovedBy || "";
        this.rejectionReason = data.rejectionReason || data.RejectionReason || "";
    }
}
